import React from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import { TextField, Typography } from "@mui/material";



export const ComTypography = ({ variant, text }) => {
  const vMediaQuery = useMediaQuery('(max-width:600px)');

  return (
    <Typography variant={variant} sx={{ letterSpacing: vMediaQuery ? "" : 1, color: "#585957", padding: "8px 0px" }}>{text}</Typography>
  );
};

export const CmpTextField = ({xId, xValue, xOnchange, xLabel,xName,xType, xError, xHelperText,xOnKeyDown }) => {
  const vMediaQuery = useMediaQuery('(max-width:600px)');

  return (
    <TextField variant={'outlined'} 
    value={xValue} 
    onChange={xOnchange} 
    label={xLabel} 
    id={xId}
    name={xName} 
    type={xType}
    error={xError}
    helperText={xHelperText}
    onKeyDown={xOnKeyDown}
    fullWidth
    autoComplete='off'
    ></TextField>
  )
};